import "./comingSoon.css";

const ComingSoon = ({ title }) => {
  return (
    <div className="comingsoon-page">
      <div className="comingsoon-content">
        <img src="/assets/images/logo-new.png" alt="" />
        <h1>{title}</h1>
        <h2>Coming Soon...</h2>
      </div>
    </div>
  );
};

export default ComingSoon;
